export const TikTokIcon = ({ className = "w-4 h-4" }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

export const TIKTOK_LINKS = [
  { handle: "@alwaysforeve7", url: "https://www.tiktok.com/@alwaysforeve7?_r=1&_t=ZP-99WUwQGXtrr" },
  { handle: "@alwaysforver98", url: "https://www.tiktok.com/@alwaysforver98?_r=1&_t=ZP-99WV30miiAZ" },
];

export const PAYMENT_METHODS = [
  { id: "zelle", label: "Zelle", details: ["331-204-2111", "ahmadmalexa@gmail.com"] },
  { id: "cashapp", label: "Cash App", details: ["$moni2773"] },
];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};
